import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { fromEvent, merge, Observable, of, TimeoutError } from "rxjs";
import "rxjs/add/operator/do";
import "rxjs/add/operator/timeout";
import { mapTo } from "rxjs/operators";
import { MESSAGE_TOAST } from "src/app/shared/enums/message-toast-enum";
import { HTTP_STATUS_CODE } from "src/app/shared/model/restful-api.model";
import { Spinner } from "../services/spinner.service";

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  online$: Observable<boolean>;
  connectionStatus: boolean;
  constructor(
    private spinner: Spinner,
    private translate: TranslateService,
    private toastService: ToastrService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.online$ = merge(
      of(navigator.onLine),
      fromEvent(window, "online").pipe(mapTo(true)),
      fromEvent(window, "offline").pipe(mapTo(false))
    );
    this.online$.subscribe((value) => (this.connectionStatus = value));
    const timeoutValue = request.headers.get("TimeoutValue");
    let handler = next.handle(request);
    if (request.url.indexOf("/blobstore") > -1) {
      handler = handler.timeout(2 * 60 * 60 * 1000);
    } else if (!timeoutValue || isNaN(Number(timeoutValue))) {
      handler = handler.timeout(10 * 60 * 1000);
    } else if (Number(timeoutValue) === -1) {
      handler = handler.timeout(2 * 60 * 60 * 1000);
    } else {
      handler = handler.timeout(Number(timeoutValue) * 1000);
    }
    return handler.do(
      (event: HttpEvent<any>) => {},
      (err: any) => {
        this.checkInstanceofError(err);
        this.spinner.hide();
      }
    );
  }

  checkInstanceofError(err) {
    if (err instanceof TimeoutError) {
    } else if (err instanceof HttpErrorResponse) {
      this.checkSatusError(err);
    }
  }

  checkSatusError(err) {
    switch (err.status) {
      case HTTP_STATUS_CODE.INTERNAL_ERROR:
        if (
          err.error.message &&
          err.error.message !== "" &&
          err.error.message.includes("service.access.time.out")
        ) {
          this.toastService.error(MESSAGE_TOAST.ERROR_SESSION_TIME_OUT);
          setTimeout(() => {
            window.location.href = "/logout";
          }, 5000);
        } else {
          this.toastMessageError(err, MESSAGE_TOAST.INTERNAL_SERVER_ERROR);
        }
        break;
      case HTTP_STATUS_CODE.FORBIDDEN:
        this.toastMessageError(err, MESSAGE_TOAST.FORBIDDEN);
        break;
      case HTTP_STATUS_CODE.UNAUTHORIZED:
        this.toastMessageError(err, MESSAGE_TOAST.ACCESS_DENIED);
        break;
      case HTTP_STATUS_CODE.BAD_REQUEST:
        this.toastMessageError(err, "");
        break;
      case HTTP_STATUS_CODE.NOTFOUND:
        this.toastMessageError(err, "");
        break;
      default:
        break;
    }
  }

  toastMessageError(err, message?) {
    if (err.error.message) {
      if (err.error.message.includes("ECONNREFUSED")) {
        if (message) {
          this.toastService.error(message)
        }
      } else {
        this.toastService.error(err.error.message)
      }
    } else {
      if (message) {
        this.toastService.error(message)
      }
    }

    // this.toastService.error(
    //   err.error.message && err.error.message !== ""
    //     ? err.error.message.includes("ECONNREFUSED")
    //       ? message
    //       : err.error.message
    //     : message
    // );
  }
}
